import { ref } from "vue";

// Create shared state outside the composable to maintain singleton behavior
const basketUpdateTrigger = ref(0);

/**
 * Composable for handling shop-related events and communication
 * Uses Vue's reactivity system to manage state and trigger updates
 */
export function useShopEvents() {
    /**
     * Triggers a basket update event
     * Components watching the trigger will be notified to update their state
     */
    function triggerBasketUpdate() {
        basketUpdateTrigger.value++;
    }

    return {
        triggerBasketUpdate,
        basketUpdateTrigger,
    };
}
